import { render, staticRenderFns } from "./exocad.vue?vue&type=template&id=fd24b808&scoped=true"
import script from "./exocad.vue?vue&type=script&lang=js"
export * from "./exocad.vue?vue&type=script&lang=js"
import style0 from "./exocad.vue?vue&type=style&index=0&id=fd24b808&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/.pnpm/vue-loader@15.11.1_5qbk3fxidqh42wxgbx7uqb2gxe/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fd24b808",
  null
  
)

export default component.exports